module.exports = __webpack_public_path__ + "img/video_cover.fe6dfc32.png";